import { Navigate, useLocation } from "react-router-dom";
import { useOrganizerAuth } from "./OrganizerAuthContext";

export default function ProtectedOrganizerRoute({ children }) {
  const { organizer, checking } = useOrganizerAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-linen" data-testid="organizer-auth-checking">
        <div className="text-center">
          <div className="w-10 h-10 mx-auto rounded-full border-2 border-espresso/20 border-t-espresso animate-spin" />
          <p className="mt-3 text-xs uppercase tracking-[0.28em] text-espresso-muted">Đang xác thực…</p>
        </div>
      </div>
    );
  }

  if (!organizer) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/organizer/login?next=${next}`} replace />;
  }

  return children;
}
